export interface MarkdownDocumentConfig {
  slug: string;
  title: string;
  browserTitle: string;
  markdownPath: string;
  serverFilePath: string;
  effectiveDate?: string;
}
// These are the markdown documents that we want to make available and prerender. Each document has a slug(url path).
// The slugs for TermsOfService and PrivacyPolicy should define the current documents. Other slugs can be used for historical versions of the documents.
export const MARKDOWN_DOCUMENTS: MarkdownDocumentConfig[] = [
  // #region Terms of Service
  {
    slug: 'TermsOfService',
    title: 'Terms of Service',
    browserTitle: 'Terms of Service - HutchAMS',
    markdownPath: 'assets/legal/terms/TOS_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/terms/TOS_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  {
    slug: 'TermsOfService20260526',
    title: 'Terms of Service 2026-05-26',
    browserTitle: 'Terms of Service 2026-05-26 - HutchAMS',
    markdownPath: 'assets/legal/terms/TOS_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/terms/TOS_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  // #endregion Terms of Service
  // #region Privacy Policy
  {
    slug: 'PrivacyPolicy',
    title: 'Privacy Policy',
    browserTitle: 'Privacy Policy - HutchAMS',
    markdownPath: 'assets/legal/privacy/PP_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/privacy/PP_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  {
    slug: 'PrivacyPolicy20260526',
    title: 'Privacy Policy 2026-05-26',
    browserTitle: 'Privacy Policy 2026-05-26 - HutchAMS',
    markdownPath: 'assets/legal/privacy/PP_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/privacy/PP_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  // #endregion Privacy Policy
  // #region Content Guidelines
  {
    slug: 'ContentGuidelines',
    title: 'Content Guidelines',
    browserTitle: 'Content Guidelines - HutchAMS',
    markdownPath: 'assets/legal/guidelines/CG_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/guidelines/CG_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  {
    slug: 'ContentGuidelines20260526',
    title: 'Content Guidelines 2026-05-26',
    browserTitle: 'Content Guidelines 2026-05-26 - HutchAMS',
    markdownPath: 'assets/legal/guidelines/CG_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/guidelines/CG_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  // #endregion Content Guidelines  
  // #region Transfer Network Policy
  {
    slug: 'TransferNetworkPolicy',
    title: 'Transfer Network Policy',
    browserTitle: 'Transfer Network Policy - HutchAMS',
    markdownPath: 'assets/legal/transfernetwork/TNP_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/transfernetwork/TNP_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  {
    slug: 'TransferNetworkPolicy20260526',
    title: 'Transfer Network Policy 2026-05-26',
    browserTitle: 'Transfer Network Policy 2026-05-26 - HutchAMS',
    markdownPath: 'assets/legal/transfernetwork/TNP_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/transfernetwork/TNP_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  // #endregion Transfer Network Policy
  // #region Security and Responsible Disclosure Policy
  {
    slug: 'SecurityAndResponsibleDisclosurePolicy',
    title: 'Security and Responsible Disclosure Policy',
    browserTitle: 'Security and Responsible Disclosure Policy - HutchAMS',
    markdownPath: 'assets/legal/security/SRDP_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/security/SRDP_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  {
    slug: 'SecurityAndResponsibleDisclosurePolicy20260526',
    title: 'Security and Responsible Disclosure Policy 2026-05-26',
    browserTitle: 'Security and Responsible Disclosure Policy 2026-05-26 - HutchAMS',
    markdownPath: 'assets/legal/security/SRDP_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/security/SRDP_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  // #endregion Security and Responsible Disclosure Policy  
  // #region API and Integration Policy
  {
    slug: 'APIAndIntegrationPolicy',
    title: 'API and Integration Policy',
    browserTitle: 'API and Integration Policy - HutchAMS',
    markdownPath: 'assets/legal/api/AIP_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/api/AIP_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  {
    slug: 'APIAndIntegrationPolicy20260526',
    title: 'API and Integration Policy 2026-05-26',
    browserTitle: 'API and Integration Policy 2026-05-26 - HutchAMS',
    markdownPath: 'assets/legal/api/AIP_2026_05_26.md',
    serverFilePath: 'dist/hutchams-app/browser/assets/legal/api/AIP_2026_05_26.md',
    effectiveDate: '2026-05-26'
  },
  // #endregion API and Integration Policy  
];